import { getPlatform } from "@/utils/platform";
import { getBaseurl, urlQueryObject } from "@/utils/url-parse";
import { API } from "@akc/biz-api";
import Cookie from "js-cookie";
import { Request } from "./request";
const baseurl = getBaseurl();
const { isSaas, isMini, isApp } = getPlatform();

const getLiveToken = () => {
  let tokenKey = isMini ? "x-mini-auth-token" : "x-auth-token";
  tokenKey = isSaas ? "x-saas-auth-token" : tokenKey;
  let tokenValue = Cookie.get("x-h5-auth-token-live-sdk");
  if (isApp) {
    tokenValue = Cookie.get("x-app-auth-token-live-sdk");
  } else if (isMini || isSaas) {
    const { live_sdk_token = "" } = urlQueryObject();
    tokenValue = live_sdk_token;
  }
  return {
    tokenKey,
    tokenValue,
  };
};

export type LiveData = {
  couponType: number;
  coverUrl: string;
  liveNo: string;
  liveStatus: number;
  liveTitle: string;
  planBeginTime: string;
};

export async function getLiveData(activityId: string): Promise<LiveData> {
  const res = await Request({
    url: `${process.env.REACT_APP_BASE_URL}/api/commodity/live/getLiveData/${localStorage.getItem(
      "shopId",
    )}/${activityId}`,
    method: "post",
  });
  return res?.data;
}

export async function queryLiveDataByCustompage(data: any): Promise<LiveData> {
  const res = await Request({
    url: `${getBaseurl()}/api/mshop/mshop-aggr-prod/outer/custompage/component/common/live`,
    method: "post",
    data,
  });
  return res?.data;
}

export async function queryLiveDetailServ(liveNo: string): Promise<LiveData> {
  const res = await Request({
    url: `${process.env.REACT_APP_LIVE}/api/live/query/queryLiveDetail?shopId=${localStorage.getItem(
      "shopId",
    )}&liveNo=${liveNo}`,
    method: "get",
    withCredentials: false,
  });
  return res?.data;
}
// // 饷店-分页查询爱库存/饷店直播频道列表，项目调用返回结果
// export const getLiveListAjax = params => {
//   return API.get({
//     path: `${process.env.REACT_APP_BASE_URL}/api/live/v1/mshop/viewer/pageQueryLiveList`,
//     body: params,
//   });
// };

// // 预约观看直播后，项目调用
// export const appointLiveAjax = params => {
//   return API.post({
//     path: `${ process.env.REACT_APP_BASE_URL}/api/live/v1/third/party/viewer/appointment`,
//     body: params,
//   });
// };

// 获取直播详情
export const getLiveDetailAjax = params => {
  return API.get({
    path: `${process.env.REACT_APP_LIVE_URL}/api/live/query/queryLiveDetail`,
    body: params,
    withCredentials: false,
  });
};

// // 直播列表(素材直播)
// export const getMaterialLiveListAjax = params => {
//   return API.get({
//     path: `${ process.env.REACT_APP_BASE_URL}/api/live/v1/radioStation/viewer/page/radio`,
//     body: params,
//   });
// };
// // 素材转发统计
// export const forwardStatisticAjax = params => {
//   return API.post({
//     path: `${ process.env.REACT_APP_BASE_URL}/api/live/v1/radioStation/forwardProduct/statistics`,
//     body: params,
//   });
// };
// // APP-发现-爱豆学堂直播课列表
// export const schoolSearchAjax = params => {
//   return API.post({
//     path: `${ process.env.REACT_APP_BASE_URL}/api/live/v1/school/search`,
//     body: params,
//   });
// };
// // 素材转发统计
// export const schoolPicAjax = params => {
//   return API.get({
//     path: `${ process.env.REACT_APP_BASE_URL}/api/live/v1/school/pic`,
//     body: params,
//   });
// };
// //  是否有直播(日历)
// export const schoolExistLiveAjax = params => {
//   return API.post({
//     path: `${ process.env.REACT_APP_BASE_URL}/api/live/v1/school/existLive`,
//     body: params,
//   });
// };
// //  学堂直播，精彩回顾
// export const schoolPageAjax = params => {
//   return API.post({
//     path: `${ process.env.REACT_APP_BASE_URL}/api/live/v1/school/page`,
//     body: params,
//   });
// };
// //  学堂直播，查询标签列表
// export const schoolQueryTagListAjax = params => {
//   return API.get({
//     path: `${ process.env.REACT_APP_BASE_URL}/api/live/v1/school/queryTagList`,
//     body: params,
//   });
// };
// // 保存地址
// export const addAddressAjax = params => {
//   return API.post({
//     path: `${ process.env.REACT_APP_BASE_URL}/api/live/v1/reward/addAddress`,
//     body: params,
//   });
// };
// // 922批量直播查询
// export const batchQueryLiveAjax = params => {
//   return API.post({
//     path: `${ process.env.REACT_APP_BASE_URL}/api/live/v1/mshop/viewer/batch/live`,
//     body: params,
//   });
// };
// //  直播大赛，查询tab设置
// export const queryTabSetAjax = params => {
//   return API.get({
//     path: `${ process.env.REACT_APP_BASE_URL}/api/live/v1/competition/querytabSet`,
//   });
// };
// //  直播大赛，查询tab设置
// export const tabSetAjax = params => {
//   return API.post({
//     path: `${ process.env.REACT_APP_BASE_URL}/api/live/v1/competition/tabSet`,
//     body: params,
//   });
// };

// // 添加购物车发送IM消息
// export const addCartIMAjax = params => {
//   return API.post({
//     path: `${ process.env.REACT_APP_BASE_URL}/api/live/viewer/addProductList`,
//     body: params,
//   });
// };
// // 直接购买发送IM消息
// export const toOrderIMAjax = params => {
//   return API.post({
//     path: `${ process.env.REACT_APP_BASE_URL}/api/live/viewer/toOrder`,
//     body: params,
//   });
// };

// 直播订阅
export const subscribeLive = params => {
  return API.post({
    path: `${baseurl}/api/shop/subscriberShopLiveShow`,
    body: params,
  });
};

// 饷店查询直播预告详情页
export const advanceNoticeDetailAjax = (params, headers?: object) => {
  const tokenKeyName = isMini ? "x-mini-auth-token" : "x-auth-token";
  return API.get({
    path: `${process.env.REACT_APP_LIVE_URL}/api/live/v1/mshop/viewer/advanceNoticeDetail`,
    body: params,
    headers: {
      ...(headers || {}),
      "live-channel": "20", //直播频道，10丝丝，20饷店
      [tokenKeyName]: Cookie.get("x-h5-auth-token-live-sdk"), //直播登录token
    },
    withCredentials: false,
  });
};

// 直播登录
export const liveUserTrusteeship = (params, headers) => {
  const tokenKeyName = isMini ? "x-mini-auth-token" : "x-auth-token";
  return API.post({
    path: `${process.env.REACT_APP_LIVE_URL}/api/live/v1/third/user/trusteeship`,
    body: params,
    headers: {
      ...(headers || {}),
      "live-channel": "20", //直播频道，10丝丝，20饷店
      [tokenKeyName]: Cookie.get("x-h5-auth-token-live-sdk"), //直播登录token
    },
    withCredentials: false, //REACT_APP_LIVE_URL是支持跨域的，设置withCredentials=true会导致跨域放行失败
  });
};

// 用户抽奖记录查询
export const queryUserLiveRecords = (params, headers?: object) => {
  const tokenInfo = getLiveToken();
  return API.post({
    path: `${process.env.REACT_APP_LIVE_URL}/api/live/v1/reward/query/userRecords`,
    body: params,
    headers: {
      "live-channel": "20", //直播频道，10丝丝，20饷店
      [tokenInfo.tokenKey]: tokenInfo.tokenValue,
      ...(headers || {}),
    },
    withCredentials: false,
  });
};

// 中奖记录添加地址
export const addLiveAddress = (params, headers?: object) => {
  const tokenInfo = getLiveToken();
  return API.post({
    path: `${process.env.REACT_APP_LIVE_URL}/api/live/v1/reward/addAddress`,
    body: params,
    headers: {
      "live-channel": "20", //直播频道，10丝丝，20饷店
      [tokenInfo.tokenKey]: tokenInfo.tokenValue,
      ...(headers || {}),
    },
    withCredentials: false,
  });
};
